import { ElementTiptapPlugin } from 'element-tiptap-vue3-fixed';
// import ElementTiptap's styles
import 'element-tiptap-vue3-fixed/lib/style.css';

// locale.use(lang);
export default defineNuxtPlugin(nuxtApp => {
  // Doing something with nuxtApp
  nuxtApp.vueApp.directive('click-outside', {
    beforeMount(el, binding, vnode) {
      el.clickOutsideEvent = function(event: Event) {
        // here I check that click was outside the el and his childrens
        if (!(el == event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          binding.value(event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    }
  });

  nuxtApp.vueApp.directive('link-handler', {
    mounted(el, binding, vnode) {
      let links = el.querySelectorAll('a');
      links.forEach((link: any) => {
        link.addEventListener('click', (event: Event) => {
          event.preventDefault();
          let href = link.getAttribute('href');
          if (href && href.includes('id=')) {
            let parts = href.split('?');
            if (parts[1]) {
              let params = parts[1].split('&');
              let idParam = params.find((param: string) => param.startsWith('id='));
              if (idParam) {
                let id = idParam.split('=')[1];
                el.dispatchEvent(new CustomEvent('id', {detail: id}));
              }
            }
          } else {
            if (href) {
              if (href.startsWith('data:')) {
                const win = window.open("", "_blank");
                if (win) {
                  win.document.open();
                  win.document.write('<html><head><title>Dokument</title></head><body></body></html>');
                  win.document.body.innerHTML = `<iframe src="${href}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`;
                  win.document.close();
                }
              } else if (href.startsWith('https://')) {
                window.open(href);
              } else {
                window.open('https://' + href);
              }
            }
          }
        });
      });
    }
  });

  nuxtApp.vueApp.use(ElementTiptapPlugin, {
    lang: "de", // see i18n
    spellcheck: false, // can be overwritten by editor prop
  });
})
